import state from './moduleStatusState'
import actions from './moduleStatusActions'
import getters from './moduleStatusGetters'
import mutations from './moduleStatusMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}